import useHotjar from "react-use-hotjar";
import { useEffect } from "react";
import config from "infra/config";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function HotJarProvider({ children }: { children: any }) {
  const { initHotjar, identifyHotjar } = useHotjar();
  const { auth, isLogged } = useCurrentAuth();
  const { tenant } = useCurrentTenant();

  useEffect(() => {
    if (auth?.email && tenant?.id) {
      identifyHotjar(auth.email, {
        id: auth.id,
        email: auth.email,
        tenantId: tenant.id,
        tenantNome: tenant.nome,
      });
    }
  }, [isLogged, tenant?.id, tenant?.nome, auth?.id, auth?.email, identifyHotjar]);

  useEffect(() => {
    initHotjar(config.hotjar, 6, config.isDev, console.info);
  }, [initHotjar]);

  return <>{children}</>;
}

export default HotJarProvider;
